import { render } from "./auto-address.vue?vue&type=template&id=58f601b0"
import script from "./auto-address.vue?vue&type=script&lang=js"
export * from "./auto-address.vue?vue&type=script&lang=js"

import "./auto-address.vue?vue&type=style&index=0&id=58f601b0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__